<template>
  <div>
    <h3 class="mb-3">{{ sinister.sinisterSinisterNumber }}</h3>

    <tabs>
      <tab name="Siniestro">
        <general :roadSinister="sinister"></general>
      </tab>
      <tab name="Archivos">
        <files-view :files="files" :taxReceip="taxReceip"></files-view>
      </tab>
      <tab name="Bitácora">
        <binnacle :affected="sinister.affected.id"></binnacle>
      </tab>
    </tabs>
  </div>
</template>

<script>
import SinisterService from '@/services/sinister'
import ExtranetService from '@/services/extranet'
import TaxReceipService from '@/services/taxReceipt'

import General from '@/pages/RoadSinisters/File/General'
import FilesView from './FilesView'
import Binnacle from './Binnacle'

export default {
  name: 'SinisterView',
  components: { General, FilesView, Binnacle },
  data () {
    return {
      id: this.$route.params.id,
      sinister: Object,
      files: Array,
      taxReceip: Object,
      binnacle: []
    }
  },
  mounted() {
    SinisterService.fetch({id: this.id})
      .then((response) => { this.sinister = response })
  },
  watch: {
    sinister (value) {
      ExtranetService.fetchFiles(value.affected.id)
        .then(response => { this.files = response })
      TaxReceipService.fetchSinisterTaxReceipt(value.affected.id)
        .then(response => { this.taxReceip = response })
    } 
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/extranet/SinisterView.vue